// services/ZIndexManagerMain.js
const BASE_Z_INDEX = 2000;
const Z_INDEX_INCREMENT = 10;
const TOP_Z_INCREMENT = 1000;

class ZIndexManagerMain {
    constructor() {
      this._stickyStack = [];
      this._zIndices = new Map();
      //console.log('🎯 ZManagerMain created ONCE, BASE_Z:', BASE_Z_INDEX);
    }

    initializeStickies(stickies) {
        if (this._stickyStack.length > 0) {
           // console.warn("⚠️ Stickies already initialized. Skipping...");
            return;
        }
    
        //console.log("🛠 Initializing stickies with count:", stickies.length);
    
        this._stickyStack = stickies.map((sticky, index) => {  
            //console.log(`ℹ️ Sticky ${sticky.id} at index ${index}`); // ✅ Confirm index exists
            
            const zIndex = sticky.zIndex ?? (BASE_Z_INDEX + ((index + 1) * Z_INDEX_INCREMENT));
            this._zIndices.set(sticky.id, zIndex);
    
            //console.log(`✅ Initialized sticky ${sticky.id} with zIndex: ${zIndex}`);
            return sticky.id;
        });
    
        // console.log('📥 Init stickies:', {
        //     count: this._stickyStack.length,
        //     ids: this._stickyStack
        // });
    
        this._reindexAll();
    }
    

    bringToFront(stickyId) {
        if (!this._stickyStack.includes(stickyId)) {
          return BASE_Z_INDEX;
        }
      
        // Get current z-indices and sort them
        const existingIndices = new Set(this._zIndices.values());
        const highest = Math.max(...existingIndices, BASE_Z_INDEX);
      
        // Calculate new z-index and ensure it's unique
        let newZ = highest + TOP_Z_INCREMENT;
        while (existingIndices.has(newZ)) {
          newZ += TOP_Z_INCREMENT;
        }
      
        // console.log('⬆️ Z-index calculation:', {
        //   stickyId,
        //   oldZ: this._zIndices.get(stickyId),
        //   highest,
        //   newZ,
        //   existingIndices: Array.from(existingIndices)
        // });
      
        this._zIndices.set(stickyId, newZ);
        this._stickyStack = [
          ...this._stickyStack.filter(id => id !== stickyId),
          stickyId
        ];
      
        return newZ;
      }
    
      _getTopZIndex() {
        const highest = Array.from(this._zIndices.values())
          .filter(z => typeof z === 'number')
          .reduce((max, z) => Math.max(max, z), BASE_Z_INDEX);
        
        return highest;
      }

    addSticky(stickyId) {
      if (!this._stickyStack.includes(stickyId)) {
        const newZIndex = this._stickyStack.length > 0 
          ? this._getTopZIndex() + Z_INDEX_INCREMENT 
          : BASE_Z_INDEX;

        this._stickyStack.push(stickyId);
        this._zIndices.set(stickyId, newZIndex);
        
        return newZIndex;
      }
      return this._zIndices.get(stickyId);
    }

    removeSticky(stickyId) {
      this._stickyStack = this._stickyStack.filter(id => id !== stickyId);
      this._zIndices.delete(stickyId);
      this._reindexAll();
    }

    getStickyZIndex(stickyId) {
      return this._zIndices.get(stickyId) || BASE_Z_INDEX;
    }

    getAllZIndices() {
      return Object.fromEntries(this._zIndices);
    }

    _getTopZIndex() {
      return this._stickyStack.length > 0 
        ? this._zIndices.get(this._stickyStack[this._stickyStack.length - 1]) 
        : BASE_Z_INDEX;
    }

    _reindexAll() {
      // Save the current top z-index before reindexing
      const currentTop = this._getTopZIndex();
      const oldIndices = new Map(this._zIndices);
      
      this._zIndices.clear();
      this._stickyStack.forEach((id, index) => {
        // If it was on top, keep it on top
        if (oldIndices.get(id) === currentTop) {
          this._zIndices.set(id, currentTop);
        } else {
          const zIndex = BASE_Z_INDEX + ((index + 1) * Z_INDEX_INCREMENT * 2);
          this._zIndices.set(id, zIndex);
        }
      });

      // console.log('🔄 Reindexed all:', {
      //   stackSize: this._stickyStack.length,
      //   before: Object.fromEntries(oldIndices),
      //   after: Object.fromEntries(this._zIndices),
      //   preservedTop: currentTop
      // });
    }
}

export default ZIndexManagerMain;